import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { createDealer } from '../api/licenseService';

const CreateDealerDialog = ({ onClose, onCreated }) => {
    const [dealer, setDealer] = useState({
    name: '',
    firstName: '',
    email: '',
    phoneNumber: '',
    address: '',
    licenseCount: 0,
    isMaster: false,
  });

    const handleCreate = async () => {
        await createDealer(dealer);
        onCreated();
    };

    return (
  
      < Dialog open onClose = { onClose }>
  
        < DialogTitle > Neuen Händler erstellen</ DialogTitle >
  
        < DialogContent >
  
          < TextField
          label = "Name"
          fullWidth
          margin = "dense"
          value ={ dealer.name}
    onChange ={ (e) => setDealer({ ...dealer, name: e.target.value })}
        />
        < TextField
          label = "Vorname"
          fullWidth
          margin = "dense"
          value ={ dealer.firstName}
    onChange ={ (e) => setDealer({ ...dealer, firstName: e.target.value })}
        />
        < TextField
          label = "Email"
          fullWidth
          margin = "dense"
          value ={ dealer.email}
    onChange ={ (e) => setDealer({ ...dealer, email: e.target.value })}
        />
        < TextField
          label = "Telefon"
          fullWidth
          margin = "dense"
          value ={ dealer.phoneNumber}
    onChange ={
        (e) =>
      setDealer({ ...dealer, phoneNumber: e.target.value })
          }
        />
        < TextField
          label = "Adresse"
          fullWidth
          margin = "dense"
          value ={ dealer.address}
    onChange ={ (e) => setDealer({ ...dealer, address: e.target.value })}
        />
        < TextField
          label = "Lizenzen"
          type = "number"
          fullWidth
          margin = "dense"
          value ={ dealer.licenseCount}
    onChange ={
        (e) =>
      setDealer({ ...dealer, licenseCount: parseInt(e.target.value) })
          }
        />
        < FormControlLabel
          control ={
            < Switch
              checked={ dealer.isMaster}
        onChange ={
            (e) =>
          setDealer({
                ...dealer, isMaster: e.target.checked })
              }
            />
          }
        label = "Ist Master?"
      />

    </ DialogContent >

    < DialogActions >

      < Button onClick ={ onClose}> Abbrechen </ Button >

      < Button variant = "contained" onClick ={ handleCreate}>
        Erstellen
      </ Button >

    </ DialogActions >

  </ Dialog >
  );
        }
        ;

        export default CreateDealerDialog;
